<template>
  <div class="TableContainer">
    <slot />
  </div>
</template>

<script>
import './style.scss'

export default {
  name: 'TableContainer',
}
</script>
